<template>
<section class="carousel">
<div v-if="images.length > 0" class="pictures top-carousel" :class="'num-images-' + images.length">
<figure v-for="(img,index) in images" :class="{'active': currIndex === index}" v-on:click="next()">
<template v-if="img.picture">
  <vue-picture :imgset="img" :sizes="fullSizes" :className="img.attributes.className"></vue-picture>
  </template>
  <template v-else>
    <picture class="original" :class="img.attributes.className">
    <img :src="img.sizes.orig" :alt="img.attributes.alt" :width="img.attributes.width" :height="img.attributes.height" />
    </picture>
  </template>
  <figcaption v-if="img.attributes.title">{{img.attributes.title}}</figcaption>
  </figure>
  </div>
  <div v-if="showNav && images.length > 1" class="arrow prev icon-triangle-prev click-overlay" v-on:click="prev()"></div>
  <div v-if="showNav && images.length > 1" class="arrow next icon-triangle-next click-overlay" v-on:click="next()"></div>
  <v-touch tag="div" v-if="showNav && images.length > 1" class="arrow prev touch-overlay" v-on:tap="prev()" v-on:swiperight="prev"></v-touch>
  <v-touch tag="div" v-if="showNav && images.length > 1" class="arrow next touch-overlay" v-on:tap="next()" v-on:swipeleft="next" ></v-touch>
  <nav v-if="showNav && images.length > 1" class="horizontal circles plain ">
  <ol v-if="images.length > 0">
  <li v-for="(img,index) in images" :class="{'active': currIndex === index}" v-on:click="setActive(index)">{{(index+1)}}</li>
  </ol>
  </nav>
  </section>
</template>
<script>

import VuePicture from './VuePicture.vue'

export default {
  props: {
    images: {
      type: Array,
      default: []
    },
    fullSizes: {},
    speed: {
      type: Number,
      default: 3000
    },
    showNav: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      currIndex: 0,
      timer: null
    }
  },
  created: function() {
    var comp = this
    if (this.speed > 200 && comp.images.length > 1) {
      this.timer = setInterval(function () {
        if (comp.currIndex < (comp.images.length - 1)) {
          comp.currIndex++
        } else {
          comp.currIndex = 0
        }
      }, this.speed)
    }
  },
  methods: {
    setActive: function(index) {
      if (this.currIndex < this.images.length) {
        this.currIndex = index
      } else {
        this.index = 0
      }
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    next: function() {
      if (this.currIndex < (this.images.length - 1)) {
        this.setActive(this.currIndex + 1)
      } else {
        this.setActive(0)
      }
    },
    prev: function() {
      if (this.currIndex > 0) {
        this.setActive(this.currIndex - 1)
      } else {
        this.setActive(this.images.length - 1)
      }
    }
  },
  components: {
    VuePicture
  }
}
</script>


// WEBPACK FOOTER //
// VueSlideshow.vue?f9f3fe50